module.exports = __webpack_public_path__ + "img/icon.978beb74.png";